import * as types from './mutation-types'
import {BASE_URL} from "@/services/api";


export const loadBundles = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('bundle/collection').then((response) => {
            commit(types.ADD_BUNDLES, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadBundleApplyEnum = ({commit, dispatch, state}, data) => {
  return new Promise((resolve, reject) => {
      window.axios.get('bundle/apply/list').then((response) => {
          commit(types.LOAD_APPLIES, response.data)
          resolve(response)
      }).catch((err) => {
          reject(err)
      })
  })
}

export const loadBundleTypeEnum = ({commit, dispatch, state}, data) => {
  return new Promise((resolve, reject) => {
      window.axios.get('bundle/type/list').then((response) => {
          commit(types.LOAD_TYPES, response.data)
          resolve(response)
      }).catch((err) => {
          reject(err)
      })
  })
}

export const createBundle = ({commit, dispatch, state}, data) => {
    let formData = new FormData();

    formData.append('title', data.title);
    formData.append('description', data.description || '');
    formData.append('file', data.file);
    formData.append('apply', data.apply);
    formData.append('_method', 'POST');

    return new Promise((resolve, reject) => {
        window.axios.post('store/bundle', formData, data, {headers: {'Content-type': 'multipart/form-data'}}).then((response) => {
            resolve(response)
            commit(types.ADD_BUNDLE, response.data.bundle)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateBundle = ({commit, dispatch, state}, data) => {
    const formData = new FormData();
    let formatApply = []

    formData.append('title', data.title);
    formData.append('description', data.description || '');
    formData.append('file', data.file);
    formData.append('online', data.online);
    formData.append('type', data.type);
    formData.append('discount', data.discount);
    formData.append('apply', data.apply);
    (data.shops || []).forEach((shopId, index) => {
        formData.append(`shops[${index}]`, shopId);
    });
    formData.append('_method', 'PUT');

    return new Promise((resolve, reject) => {
        window.axios.post('update/' + data.id + '/bundle', formData, data, {headers: {'Content-type': 'multipart/form-data'}}).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteBundle = ({commit, dispatch, state}, id) => {
    return new Promise((resolve, reject) => {
        window.axios.delete('delete/' + id + '/bundle').then((response) => {
            commit(types.ADD_BUNDLES, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const showBundle = ({commit, dispatch, state}, id) => {
  return new Promise((resolve, reject) => {
      window.axios.get('bundle/' + id).then((response) => {
          resolve(response)
      }).catch((err) => {
          reject(err)
      })
  })
}

export const setBundleOnline = ({commit, dispatch, state}, id) => {
    return new Promise((resolve, reject) => {
        window.axios.put('set/bundle/' + id + '/online').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const storeOrUpdateBundleProducts = ({commit, dispatch, state}, data) => {
  return new Promise((resolve, reject) => {
      window.axios.post('store-or-update/bundle/' + data.id + '/products', data).then((response) => {
          resolve(response)
      }).catch((err) => {
          reject(err)
      })
  })
}

export const removeProductOnBundle = ({commit, dispatch, state}, id) => {
  return new Promise((resolve, reject) => {
      window.axios.delete('remove/product/' + id + '/bundle').then((response) => {
          resolve(response)
      }).catch((err) => {
          reject(err)
      })
  })
}

export const removeShopInBundle = ({commit, dispatch, state}, id) => {
  return new Promise((resolve, reject) => {
      window.axios.delete('remove/shop/' + id + '/bundle').then((response) => {
          resolve(response)
      }).catch((err) => {
          reject(err)
      })
  })
}


export const getProductsPerCategories = ({commit, dispatch, state}) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/products/groupBy/category').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const getProductSalesPerProducts = ({commit, dispatch, state}, products) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/productSaleElements/by/products', {
            params: {
                products: products
            }
        }).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}